<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <popUp v-if="toggle" v-on:doClose="close" :size="'small'">
      <div class="pop-title" slot="title">
        <h3>新增考場</h3>
        <div class="d-flex align-items-center">
          <label class="m-0 mr-2">考場名稱:</label>
          <input type="text" v-model="examName">
        </div>
        <div class="my-2">
          <div class="d-flex align-items-center">
            <label class="m-0 mr-2">日期區間:</label>
            <date-picker valueType="format" v-model="range" :format="'YYYY-MM-DD HH:mm'" :showTimeHeader="true" type="datetime" :showSecond="false" range placeholder="請選擇日期區間"></date-picker>
          </div>
        </div>
        <div class="my-2" style="text-align: left;">
          <label>備註:</label>
          <div class="d-flex align-items-center">
            <textarea v-model="note" placeholder="新增備註" style="resize:none;width:600px;height:200px;"></textarea>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <input type="checkbox" id="playableCheckbox" v-model="playableChecked">
          <span class="ml-2" for="checkbox">學生考試時，可播放範例音檔</span>
        </div>
        <div class="d-flex align-items-center">
          <input type="checkbox" id="repeatCheckbox" v-model="repeatChecked">
          <span class="ml-2" for="checkbox">開放學生作答時重複錄音,作答以最後一次錄音為準</span>
        </div>
        <div class="d-flex align-items-center">
          <input type="checkbox" id="playableCheckbox" v-model="showScoreChecked">
          <span class="ml-2" for="checkbox">立即顯示測驗分數</span>
        </div>
        <button style="float: right;" type="button" :disabled="!examName" @click="addRoom" class="btn btn-danger">新增考場</button>
      </div>
    </popUp>
    <div class="row">
      <div class="col-12">
        <div class="d-flex menu">
          <div @click="goTitlePage('Room')"  class="title d-sm-flex pointer active">
            <div class="my-auto">
              考場設定
            </div>
          </div>
          <div @click="goTitlePage('Score')" class="title d-sm-flex pointer">
            <div class="my-auto">
              考試成績
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-2" style="min-height:40vh"  v-if="previewToggle===false">
        <div class="d-flex align-items-center justify-content-between">
          <button type="button" class="btn btn-danger" @click="toggle=true">+ 新增考場</button>
          <div>
            <select v-model="pageSize">
              <option value="10" selected>顯示10筆</option>
              <option value="50" >顯示50筆</option>
              <option value="100" >顯示100筆</option>
            </select>
            <select class="mx-2" v-model="examStatus">
              <option value="" selected>全部</option>
              <option value="not_finish" >未開始及進行中</option>
              <option value="prepare" >未開始</option>
              <option value="in_progress" >進行中</option>
              <option value="finish" >已結束</option>
            </select>
          </div>
        </div>
        <table class="rwd-table mt-3">
            <tbody>
              <tr>
                <th>考場名稱</th>
                <th>開始時間</th>
                <th>結束時間</th>
                <th>狀態</th>
                <th>教師</th>
                <th>成績</th>
                <th>修改</th>
                <th>刪除</th>
                <th>預覽</th>
                <th>複製</th>
              </tr>
              <tr v-for="(item, index) in roomList" :key="index">
                <td data-th="考場名稱">
                  {{item.name}}
                </td>
                <td data-th="開始時間">
                  {{item.begin_at}}
                </td>
                <td data-th="結束時間">
                  {{item.end_at}}
                </td>
                <td data-th="狀態">
                  {{changeStatus(item.status)}}
                </td>
                <td data-th="教師">
                  <span v-if="item.creator">{{item.creator.name}}</span>
                </td>
                <td data-th="成績">
                  {{item.score}}
                </td>
                <td data-th="修改">
                  <button v-if="!item.is_lock && personalData.name === item.creator.name" type="button" class="btn btn-primary" @click="goModifyPage(item.id)">修改</button>
                  <button v-else type="button" class="btn btn-primary" disabled>鎖定</button>
                </td>
                <td data-th="刪除">
                  <button v-if="!item.is_lock && personalData.name === item.creator.name" type="button" @click="removeRoom(item.id)" class="btn btn-primary">刪除</button>
                  <button v-else type="button" class="btn btn-primary" disabled>鎖定</button>
                </td>
                <td data-th="預覽">
                  <button type="button" @click="examPreview(item.id)" class="btn btn-primary">預覽</button>
                  <!-- <button v-else type="button" class="btn btn-danger" disabled>鎖定</button> -->
                </td>
                <td data-th="複製">
                  <button type="button" @click="copyExam(item.id)" class="btn btn-primary">複製</button>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <pagination v-if="pageCount>1" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
          </div>
      </div>
      <div class="col-12" v-if="previewToggle===true">
        <div v-if="currentDetail=== false">
          <table class="rwd-table my-3" v-if="examData">
            <tbody>
              <tr>
                <th>題號</th>
                <th>單元名稱</th>
                <th>瀏覽題目</th>
              </tr>
              <tr v-for="(item, index) in examData" :key="index">
                <td data-th="題號">
                  {{index + 1}}
                </td>
                <td data-th="單元名稱">
                  {{item.name}}
                </td>
                <td data-th="瀏覽題目">
                  <!-- <button type="button" @click="examSentencesPreview(item,index)" class="btn btn-outline-primary" :class="{'active': index === selectedIndex}">預覽</button> -->
                  <button type="button" @click="examSentencesPreview(item,index)" class="btn btn-outline-primary" >預覽</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="currentDetail === true">
          <select class="my-3" v-model="showAll" style="float: right;">
            <option value="true" selected>全部</option>
            <option value="false" >隱藏未選擇題目</option>
          </select>
          <div v-if="examData" v-for="(item, index) in examSentences" :key="index">
            <div v-if="showAll === 'true'">
              <div @click="playAudio(item.no)" style="width:100%" :class="{'sentencesActive':item.no===current}" v-if="item.is_selected=== true" class="alert alert-primary d-flex justify-content-between align-items-center py-3 pointer">
                {{ item.text }}</div>
              <div @click="playAudio(item.no)" style="width:100%" :class="{'sentencesActive':item.no===current}" v-else class="alert alert-secondary d-flex justify-content-between align-items-center pointer py-3">{{ item.text }}</div>
            </div>
            <div v-else>
              <div @click="playAudio(item.no)" style="width:100%" :class="{'sentencesActive':item.no===current}" v-if="item.is_selected=== true" class="alert alert-primary d-flex justify-content-between align-items-center py-3 pointer">{{ item.text }}</div>
            </div>
            <audio v-if="examSentences" :id="`audio${item.no}`">
              <source :src="item.audio" type="audio/mp3">
            </audio>
          </div>
        </div>
        <button type="button" @click="back()" class="btn btn-primary">返回</button>
      </div>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination.vue'
import PopUp from '@/components/PopUp.vue'
import LineChart from '../../LineChart.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import api from '../../../store/api'
import Personal from '../../../views/Personal.vue'
export default {
  name: 'Room',
  props: {
    personalData: {
      required: true
    }
  },
  data () {
    return {
      roomList: [],
      title: 'Room',
      toggle: false,
      examStatus: 'not_finish',
      currentDetail: false,
      range: ['' , ''],
      examName: '',
      note: '',
      examData: null,
      examSentences: [],
      playableChecked: true,
      repeatChecked: true,
      showScoreChecked: true,
      showAll: false,
      current: null,
      previewToggle: false,
      selectedIndex: null,
      pageSize: 100,
      pageCount: 10,
      pageIndex: 1
    }
  },
  computed: {
    groupId () {
      return this.$route.params.groupId
    }
  },
  components: {
    DatePicker,
    Pagination,
    PopUp,
    LineChart
  },
  watch: {
    examStatus (val) {
      this.pageIndex = 1
      this.getRoomList()
    },
    pageSize (val) {
      this.pageIndex = 1
      this.getRoomList()
    }
  },
  async mounted () {
    await this.getRoomList()
  },
  methods: {
    async getRoomList () {
      const { data } = await api.get(`liveabc/rooms?group_id=${this.groupId}&status=${this.examStatus}&page=${this.pageIndex}&pageSize=${this.pageSize}`)
      this.roomList = data.data
      this.pageCount = data.pageCount
      this.pageIndex = data.pageIndex
    },
    changeStatus (txt) {
      switch (txt) {
      case 'not_finish':
        return '未開始及進行中';
      case 'prepare':
        return'未開始';
      case 'in_progress':
        return '進行中';
      case 'finish':
        return '已結束';
      default:
        return
      }
    },
    goTitlePage (el) {
      this.title = el
      this.$router.push({ name: el, params:{ groupId: this.groupId}})
    },
    goModifyPage (roomId) {
      this.$router.push({ name: 'ModifyRoom', params:{ groupId: this.groupId, roomId: roomId}})
    },
    async removeRoom (id) {
      let self = this
      self.$swal({
        title: '確認刪除?',
        text: '資料刪除後無法復原',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        closeOnConfirm: false
      }).then(function (isConfirm) {
        if (isConfirm.value === true) {
          self.deleteRoom(id)
        }
      })
    },
    async deleteRoom (id) {
      const { data } = await api.delete(`liveabc/rooms/${id}?force_delete=true`)
      await this.getRoomList()
    },
    async copyExam (id) {
      const { data } = await api.post(`liveabc/rooms/${id}/duplicate?group_id=${this.groupId}`)
      await this.getRoomList()
    },
    async examPreview (id) {
      const { data } = await api.get(`liveabc/rooms/${id}/preview`)
      this.examData = data.data
      this.previewToggle = true
    },
    examSentencesPreview (item, idx) {
      this.examSentences = item.sentences
      this.selectedIndex = idx
      this.currentDetail = true
    },
    async addRoom () {
      try {
        const fileData = new window.FormData()
        fileData.append('name', this.examName)
        fileData.append('type', 'oral_test')
        fileData.append('begin_at', this.range[0])
        fileData.append('end_at', this.range[1])
        fileData.append('sound_playable', this.playableChecked)
        fileData.append('is_show_score', this.playableChecked)
        fileData.append('is_repeatable', this.repeatChecked)
        fileData.append('note', this.note)
        const { data } = await api.post(`liveabc/rooms`, fileData)
        console.log(data)
        this.toggle = false
        this.getRoomList()
        this.examName = ''
        this.range = ['', '']
        this.$router.push({ name: 'ModifyRoom', params:{ groupId: this.groupId, roomId: data.data.id}})
      } catch (error) {
        this.$swal({
          title: '新增考場失敗，請設定考試日期',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        console.error(error.response.data)
      }
    },
    playAudio (id) {
      this.current = id
      let audio = document.getElementById(`audio${id}`)
      this.pauseAll()
      audio.load()
      audio.play()
    },
    pauseAll () {
      const audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    back () {
      if (this.currentDetail) {
        this.currentDetail = false
      } else {
        this.previewToggle = false
      }
      this.examSentences = []
    },
    close (close) {
      this.toggle = close
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getRoomList()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/color.scss";
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  .pop-box {
    width: 500px !important;
  }
  .menu {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 10px 30px 10px 0;
    }
  }
  .sentencesActive {
    font-weight: bold;
    box-shadow: rgb(168, 168, 168) 5px 5px 15px;
  }
  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .active {
    font-weight: bolder;
    color: black;
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      font-weight: bolder;
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
  button  {
    display: none;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>

